import * as T from '@clientos/types';
import BreadcrumbService from '../../../services/breadcrumbService';
import { getServices } from '../../../infra/startup';
import bindAllMethods from '../../../utils/bindAllMethods';
import { internalLogger } from '../clientOsLogger';

export default class Breadcrumb implements T.BreadcrumbInterfaceType {
  private _breadcrumbService: BreadcrumbService;
  constructor() {
    const services = getServices();
    this._breadcrumbService = services?.breadcrumbService;
    bindAllMethods(this);
  }

  listen(callback: T.BreadcrumbListenerCallbackType): () => void {
    return this._breadcrumbService.listen(callback);
  }

  useReactListener(React: any): T.BreadcrumbItemType[] {
    return this._breadcrumbService.useReactListener(React);
  }

  getBreadcrumbs(): T.BreadcrumbItemType[] {
    return this._breadcrumbService.getBreadcrumbs();
  }

  add(breadcrumbItem: T.BreadcrumbItemType): void {
    this._breadcrumbService.add(breadcrumbItem);
  }

  isEnabled(): boolean {
    return this._breadcrumbService.isEnabled();
  }

  remove(breadcrumbKey: string): void {
    this._breadcrumbService.remove(breadcrumbKey);
  }
}

export function createNoopBreadcrumbInteface(): T.BreadcrumbInterfaceType {
  return {
    listen: function (): () => void {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopBreadcrumbInteface',
        methodName: 'listen()',
        message: 'Noop interface method called - returning empty function'
      });
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {};
    },
    useReactListener: function (): T.BreadcrumbItemType[] {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopBreadcrumbInteface',
        methodName: 'useReactListener()',
        message: 'Noop interface method called - returning empty array'
      });
      return [];
    },
    getBreadcrumbs: function (): T.BreadcrumbItemType[] {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopBreadcrumbInteface',
        methodName: 'getBreadcrumbs()',
        message: 'Noop interface method called - returning empty array'
      });
      return [];
    },
    add: function (breadcrumbItem: T.BreadcrumbItemType): void {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopBreadcrumbInteface',
        methodName: 'add()',
        message: 'Noop interface method called - no operation performed'
      });
    },
    isEnabled: function (): boolean {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopBreadcrumbInteface',
        methodName: 'isEnabled()',
        message: 'Noop interface method called - returning false'
      });
      return false;
    },
    remove: function (breadcrumbKey: string): void {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopBreadcrumbInteface',
        methodName: 'remove()',
        message: 'Noop interface method called - no operation performed'
      });
    }
  };
}
